var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"display"},[_c('h1',{style:({'font-family': _vm.font})},[_vm._v(_vm._s(_vm.chassi))])])}
var staticRenderFns = []

export { render, staticRenderFns }